module.exports = "<span>{{ 'kiosk.help' | translate }}</span>\n<petal-logo-dark [height]=\"40\" [width]=\"85\"></petal-logo-dark>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/kiosk/kiosk-footer/kiosk-footer.component.html
// module id = 1257
// module chunks = 0